import { useIsMobile } from "@/hooks/useIsMobile";
import PCAuthHeader from "./pc-auth-header/PCAuthHeader";
import { JSX } from "react";

interface Props {
  children: JSX.Element[];
  title: string;
  className?: string;
  isFromCheckout?: boolean;
  onClickBack?: () => void;
}

const AuthContainer: React.FC<Props> = ({
  title,
  children,
  className = null,
  isFromCheckout,
  onClickBack,
}) => {
  const mobile = useIsMobile();
  const pc = !mobile;
  const cn = `auth-container ${isFromCheckout ? "popup" : ""} ${
    pc ? "pc" : ""
  }`;
  const registerFormCn = `register-container ${
    isFromCheckout ? "popup" : ""
  }  ${pc ? "pc" : ""}`;

  return (
    <div
      className={className ? registerFormCn : cn}
      style={
        mobile
          ? {
              marginBottom: isFromCheckout ? 25 : 150,
              height: isFromCheckout ? "100%" : undefined,
              overflow: "auto",
            }
          : {}
      }
    >
      {pc && (
        <div
          className={`w-100 ${isFromCheckout && pc ? "sticky-header" : ""}`}
          style={className ? { padding: "0 24px" } : {}}
        >
          <PCAuthHeader title={title} onClickBack={onClickBack} />
        </div>
      )}
      {children}
    </div>
  );
};

export default AuthContainer;
